export default "__VITE_ASSET__DVYpQqqb__"